import { render, staticRenderFns } from "./InstallStepsSection.vue?vue&type=template&id=1f92b2ab&scoped=true"
import script from "./InstallStepsSection.vue?vue&type=script&lang=js"
export * from "./InstallStepsSection.vue?vue&type=script&lang=js"
import style0 from "./InstallStepsSection.vue?vue&type=style&index=0&id=1f92b2ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f92b2ab",
  null
  
)

export default component.exports